import { cdiService } from '../services'

export default (type, bdParams) => {
	return new Promise(resolve => {
		cdiService.newSendRequest(type, bdParams)
			.then(response => resolve(response.data))
	})
}
